import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.png';

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full border-t bg-gradient-to-b from-muted/10 to-muted/30">
      <div className="container mx-auto px-4 py-12">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="flex flex-col items-start gap-4">
            <div className="flex items-center gap-3">
              <img src={logo} alt="" className="h-10 w-10" />
              <span className="font-bold text-xl">What Size Air Purifier</span>
            </div>
            <p className="text-muted-foreground max-w-xs">
              Free sizing calculator with sourced product data. No ads, no affiliate links.
            </p>
          </div>
          
          {/* Quick Links */}
          <div className="flex flex-col gap-4">
            <h3 className="font-bold text-foreground">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              <Link 
                to="/" 
                className="text-muted-foreground hover:text-primary transition-colors duration-200 w-fit relative group"
              >
                Calculator
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
              </Link>
              <Link 
                to="/install" 
                className="text-muted-foreground hover:text-primary transition-colors duration-200 w-fit relative group"
              >
                Install App
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
              </Link>
              <Link 
                to="/methodology" 
                className="text-muted-foreground hover:text-primary transition-colors duration-200 w-fit relative group"
              >
                How it works
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
              </Link>
              <Link 
                to="/guides" 
                className="text-muted-foreground hover:text-primary transition-colors duration-200 w-fit relative group"
              >
                Room guides
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
              </Link>
              <a 
                href="https://ahamverifide.org/ach-faq/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors duration-200 inline-flex items-center gap-1.5 w-fit"
              >
                AHAM ACH FAQ
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </nav>
          </div>
          
          {/* Resources */}
          <div className="flex flex-col gap-4">
            <h3 className="font-bold text-foreground">Resources</h3>
            <nav className="flex flex-col gap-3">
              <Link 
                to="/corrections" 
                className="text-muted-foreground hover:text-primary transition-colors duration-200 w-fit relative group"
              >
                Corrections
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
              </Link>
              <Link 
                to="/privacy" 
                className="text-muted-foreground hover:text-primary transition-colors duration-200 w-fit relative group"
              >
                Privacy Policy
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-200 group-hover:w-full" />
              </Link>
              <a 
                href="https://www.epa.gov/indoor-air-quality-iaq/guide-air-cleaners-home"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors duration-200 inline-flex items-center gap-1.5 w-fit"
              >
                EPA Air Cleaner Guide
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </nav>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} What Size Air Purifier. Not medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
